module.exports = __webpack_public_path__ + "img/icon-9.fc9910af.png";